import { OnePagerContext } from './context';
import { OnePagerSectionConfig } from '../editor/dealSummaryEditorInitializer';
import {
    DATA_NOT_AVAILABLE_HIGHLIGHT as YELLOW,
    DATA_NOT_AVAILABLE_LABEL as DataNotAvl,
    UW_DEBT_SCHEDULE_DATA_HEADERS,
} from '../editor/dealSummaryEditorConstants';
import { h2, spacer, table, td, text, th, tr, TrRow } from './plateNodes';

const UW_DEBT_SCHEDULE_DATA_HEADER_NAMES: Record<string, string> = {
    lenderName: 'Lender Name',
    typeOfDebtLoan: 'Type of Debt/Loan',
    sanctionedAmount: 'Sanctioned Amount (Crs.)',
    outstandingBalance: 'O/S Balance as of Date (Crs.)',
};

export function buildDebtScheduleSection(ctx: OnePagerContext, section: OnePagerSectionConfig, debtScheduleSuffix: string): any[] | null {
    const { uw_debt_schedule_data, uw_debt_schedule_data_headers } = ctx;

    const headerRow: TrRow = uw_debt_schedule_data_headers?.length
        ? tr(uw_debt_schedule_data_headers.map((header: any) => th([text(header?.name ?? '', { bold: true })])))
        : tr(
              UW_DEBT_SCHEDULE_DATA_HEADERS.map((headerKey) =>
                  th([text(UW_DEBT_SCHEDULE_DATA_HEADER_NAMES?.[headerKey] ?? '', { bold: true })]),
              ),
          );

    const dataRows: TrRow[] =
        !!uw_debt_schedule_data?.rows?.length && !!uw_debt_schedule_data_headers?.length
            ? uw_debt_schedule_data.rows.map((row: any) =>
                  tr(uw_debt_schedule_data_headers.map((header: any) => td([text(`${row?.[header?.key] ?? ''}`)]))),
              )
            : [tr(UW_DEBT_SCHEDULE_DATA_HEADERS.map(() => td([text(DataNotAvl, { backgroundColor: YELLOW })])))];

    const totalsRows: TrRow[] =
        uw_debt_schedule_data?.rows?.length &&
        ('totalSanctionedAmount' in uw_debt_schedule_data || 'totalOutstandingAmount' in uw_debt_schedule_data)
            ? [
                  tr([
                      td([text('Total')]),
                      td([text('')]),
                      td([text(`${uw_debt_schedule_data?.totalSanctionedAmount ?? '-'}`)]),
                      td([text(`${uw_debt_schedule_data?.totalOutstandingAmount ?? '-'}`)]),
                  ]),
              ]
            : [];

    return [h2([text(`${section.label}${debtScheduleSuffix}`)]), table([headerRow, ...dataRows, ...totalsRows]), spacer()];
}
